<ng-container *ngIf="srcset">
  <ng-content></ng-content>
  <picture *ngIf="!isMobile || !mobileUrl">
    <ng-container *ngFor="let size of sizes">
      <source *ngIf="srcset['size-' + size]" media="(min-width: {{ size }}px)" [srcset]="srcset['size-' + size]" />
    </ng-container>
    <img
      [src]="getInSize(url, sizes[0] * scale)"
      [alt]="alt || ''"
      [attr.loading]="loading"
      [attr.fetchpriority]="fetchPriority"
      [width]="width"
      [height]="height"
      [style.max-width]="maxWidth ? maxWidth + 'px' : ''"
    />
  </picture>

  <picture *ngIf="isMobile && mobileUrl">
    <ng-container *ngFor="let size of sizes">
      <source
        *ngIf="mobileSrcset['size-' + size]"
        media="(min-width: {{ size }}px)"
        [srcset]="mobileSrcset['size-' + size]"
      />
    </ng-container>
    <img
      [src]="getInSize(mobileUrl, sizes[0] * scale)"
      [alt]="alt || ''"
      [attr.loading]="loading"
      [attr.fetchpriority]="fetchPriority"
      [width]="mobileWidth || width"
      [height]="mobileHeight || height"
      [style.max-width]="maxWidth ? maxWidth + 'px' : ''"
    />
  </picture>
</ng-container>
